import { Component, OnInit } from '@angular/core';
import { PointsService } from 'src/app/services/points.service';
import { NavaidModel } from 'src/app/models/navaid';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { MapService } from 'src/app/services/map.service';
import { NavaidsService } from 'src/app/services/navaids.service';

@Component({
  selector: 'app-tools-control',
  templateUrl: './tools-control.component.html',
  styleUrls: ['./tools-control.component.scss'],
  standalone: false
})
export class ToolsControlComponent implements OnInit {
  active:boolean = false;

  constructor(
    private pointsController : PointsService,
    private navaidController : NavaidsService,
    private coordinatePointsController: CoordinatePointsService,
    private mapService : MapService
    ) {

  }

  ngOnInit(): void {
  }

  toolsTrigger():void {
    this.active = !this.active;
  }

  footerTrigger(): void {
    this.navaidController.active = !this.navaidController.active;
    this.navaidController.selectedNavaid = new NavaidModel();
    this.navaidController.selectedNavaid.navaidtype = "DME";
    this.navaidController.selectedNavaid.cone= 50.0;
  }

  async footerEditNavaidTrigger(): Promise<void> {
    if(this.pointsController.getSelectedFeatures().length>0){
      this.navaidController.selectedNavaid = this.pointsController.transformFeatureInNavaid(this.pointsController.getSelectedFeatures()[0]);
      (await this.pointsController.getTerrainElevation(this.navaidController.selectedNavaid.latitude, this.navaidController.selectedNavaid.longitude)).subscribe(
        (data) => {
          this.navaidController.selectedNavaid.elevationTerrainMeters = data;
          this.navaidController.selectedNavaid.elevationTerrainFeet = this.pointsController.convertToFeet(data);

          this.navaidController.selectedNavaid.elevationRelativeTerrainMeters = this.navaidController.selectedNavaid.elevationTerrainMeters + this.navaidController.selectedNavaid.antheightMeters;
          this.navaidController.selectedNavaid.elevationRelativeTerrainFeet = this.navaidController.selectedNavaid.elevationTerrainFeet + this.navaidController.selectedNavaid.antheight;


          this.navaidController.active = !this.navaidController.active;
        }
      );

    }
  }

  deleteNavaids(){
    //this.pointsController.deleteNavaids();
  }

  coordinatePointTrigger(): void {
    this.coordinatePointsController.active = !this.navaidController.active;
    this.coordinatePointsController.selectedCoordinatePoint = new CoordinatePointModel();

  }

  editCoordinatePointTrigger(): void {
    if(this.pointsController.getSelectedFeatures().length>0){
      this.coordinatePointsController.selectedCoordinatePoint = this.pointsController.transformFeatureInCoordinatePoint(this.pointsController.getSelectedFeatures()[0]);
      this.coordinatePointsController.active = !this.coordinatePointsController.active;
    }
  }

  deleteCoordinatePoints(){
    //this.pointsController.deleteCoordinatePoints();
  }

}
